import { Dialog } from "@wg/wows-react-uikit";
import { hideDialog } from "fe2/Actions/ActionDialog";
import { connect } from "react-redux";

const mapStateToProps = state => {
  return {
    content: state.dialog.content,
    size: state.dialog.size,
    isVisible: state.dialog.isVisible,
    isOverlay: state.dialog.isOverlay
  };
};

const mapDispatchToProps = { hideDialog };

export default connect(mapStateToProps, mapDispatchToProps)(Dialog);